export default {
    shiftForm: () =>
        fetch('/config/shift/form')
            .then(resp => resp.json())
            .catch(() => ({})),
    wardConfig: () =>
        fetch('/config/ward/detail')
            .then(resp => resp.json())
            .catch(() => ({})),
}